export default __webpack_public_path__ + "static/media/pandg.c9c24ca8.png";